import React from "react";
import DirectusCombobox from "./combobox";
import EvtMultiSelectBadges from "../multiselect";
import client from "directus/src/client";
import FilterWrapper from "components/filter/wrapper";

export default function FunctionsCombobox({
  filter,
  hideLabel,
  className,
  multiselect = false,
  required,
  ...props
}) {
  if (multiselect) {
    if (hideLabel) {
      return (
        <div className={className}>
          <EvtMultiSelectBadges
            collection="functions"
            fields={["id", "name"]}
            searchKeys={["name"]}
            filter={filter}
            placeholder="Select Function"
            {...props}
          />
        </div>
      );
    }

    return (
      <FilterWrapper label="Function" className={className}>
        <EvtMultiSelectBadges
          collection="functions"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select"
          {...props}
        />
      </FilterWrapper>
    );
  }

  // Default single select behavior
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="functions"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select Function"
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper label="Function" className={className} required={required}>
      <DirectusCombobox
        client={client}
        collection="functions"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        limit={-1}
        {...props}
      />
    </FilterWrapper>
  );
}
